export default __webpack_public_path__ + "static/media/warning.1caf99cf.svg";